import {Injectable, Optional} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {I18NService} from '../i18n/i18n.service';

export class I18NMatPaginatorIntlConfig {
    itemsPerPageLabel?: string;
    nextPageLabel?: string;
    previousPageLabel?: string;
    firstPageLabel?: string;
    lastPageLabel?: string;
}

// see: https://stackoverflow.com/questions/46869616/how-to-use-matpaginatorintl
@Injectable()
export class I18NMatPaginatorIntl extends MatPaginatorIntl {

    constructor(private readonly i18n: I18NService,
                @Optional() private readonly cfg: I18NMatPaginatorIntlConfig) {
        super();
    }

    itemsPerPageLabel = this.i18n.translate(this.cfg?.itemsPerPageLabel || 'Items per page');
    nextPageLabel = this.i18n.translate(this.cfg?.nextPageLabel || 'Next page');
    previousPageLabel = this.i18n.translate(this.cfg?.previousPageLabel || 'Previous page');
    firstPageLabel = this.i18n.translate(this.cfg?.firstPageLabel || 'First page');
    lastPageLabel = this.i18n.translate(this.cfg?.lastPageLabel || 'Last page');

    getRangeLabel = (page, pageSize, length) => {
        if (length === 0 || pageSize === 0) {
            return this.i18n.translate('0 of {0}', length);
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // if the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
        return this.i18n.translate('{0} - {1} of {2}', startIndex + 1, endIndex, length);
    };
}
